<template>
    <div class="subscription-passage-view flex-between-wrapper">
      <img class="feature-image" src="/assets/app/class/quiz-frame-bg.png">
      <div class="premium-passage-view">
        <h3 class="view-title">Seamlessly align ReadTheory with your existing curriculum.</h3>
        <p class="view-description">With Premium you can use ReadTheory for a whole-class lesson by assigning a specific passage from the library! Allow students to work in groups, take a common assessment, or hold a class discussion on it.</p>
        <div class="button-wrapper">
          <primary-button @click="handleClickPlan">Choose your plan</primary-button>
        </div>
      </div>
    </div>
</template>

<script>

import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  components: {
    PrimaryButton
  },
  methods: {
    handleClickPlan() {
      this.$emit('showPlan');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-passage-view {
  padding: 128px 0;
  .feature-image {
    margin-top: -20px;
    margin-right: 10px;
  }
  .premium-passage-view {
    max-width: 397px;
  }
  @media(max-width: 900px) {
    display: block;
    .feature-image {
      margin-right: 0;
    }
    .premium-passage-view {
      max-width: none;
      margin-top: 20px;
    }
  }
  @media(max-width: 767px) {
    padding: 50px 0;
  }
}
</style>
